<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">訂單查詢</span>
          </div>
          <b-input-group class="float-right" variant="light" prepend="匯出訂單列表" style="width: 480px;">
            <template v-slot:append>
              <b-dropdown :disabled="!selectedDate" split text="下載" :variant="selectedDate? 'secondary' : 'light'"
                offset="-100%" class="border" :split-href="deliverDownloadLink('xlsx')">
                <b-dropdown-item :href="deliverDownloadLink('xlsx')" target="_blank">xlsx</b-dropdown-item>
                <b-dropdown-item :href="deliverDownloadLink('ods')" target="_blank">ods</b-dropdown-item>
              </b-dropdown>
            </template>
            <b-form-datepicker id="data-download-datepicker" v-model="selectedDate" label-no-date-selected="請先選擇日期" value-as-date></b-form-datepicker>
          </b-input-group>
        </template>
        <b-navbar class="mt-2">
          <b-navbar-nav>
            <b-form inline @submit.prevent>
              <label class="sr-only" for="state-radio-btn-outline">訂單狀態：</label>
              <b-form-radio-group id="state-radio-btn-outline" v-model="stateInput" :options="stateOptions" buttons
                button-variant="outline-info" size="sm" name="state-radio-btn-outline"
              ></b-form-radio-group>
            </b-form>
          </b-navbar-nav>
        </b-navbar>
        <b-navbar toggleable="md" class="mt-2">
          <b-navbar-nav>
            <b-nav-form inline class="mr-md-2 mt-2" @submit.prevent>
              <label class="mr-sm-2" for="inline-form-input-uqidInpu">訂單號：</label>
              <b-form-input id="inline-form-input-uqidInput" v-model="uqidInput"></b-form-input>
            </b-nav-form>
            <b-nav-form inline class="mr-md-2 mt-2" @submit.prevent>
              <label class="mr-sm-2" for="inline-form-input-ordererInput">購買人：</label>
              <b-form-input id="inline-form-input-ordererInput" v-model="ordererInput"></b-form-input>
            </b-nav-form>
            <b-nav-form inline class="mr-md-2 mt-2" @submit.prevent>
              <label class="mr-sm-2" for="inline-form-input-receiverInput">取貨人：</label>
              <b-form-input id="inline-form-input-receiverInput" v-model="receiverInput"></b-form-input>
            </b-nav-form>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item class="mr-1">
              <b-button :disabled="!selectedArray.length" variant="danger" size="sm" @click="onClickDelete">刪除訂單</b-button>
            </b-nav-item>
            <b-nav-form>
              <b-form-select v-model="each" size="sm" class="float-right">
                <b-form-select-option v-for="n in [10, 20, 30, 50]" :value="n" :key="n">每頁顯示筆數: {{ n }}</b-form-select-option>
              </b-form-select>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-table id="user-table" bordered show-empty empty-text="尚無訂單" hover :items="items" :fields="fields" :busy="Boolean(isBusy)" responsive class="mt-2">
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:head(checkbox)>
            <b-form-checkbox id="checkbox-all" @change="onClickSelectAll" :indeterminate="isParticalSelected">選取</b-form-checkbox>
          </template>
          <template v-slot:cell(checkbox)="data">
            <b-form-checkbox :id="`checkbox-${data.item.id}`" v-model="selectedArray" :value="data.item.id"></b-form-checkbox>
          </template>
          <template v-slot:cell(ops)="data">
            <b-link :to="`/admin/deliver/${data.item.id}/view`">查看訂單</b-link>
          </template>
        </b-table>
        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="each" aria-controls="user-table" class="float-right"></b-pagination>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import moment from 'moment'
import QueryString from 'querystring'
import { Payments, DeliverStates } from '../../library/Var.js'
export default {
  data () {
    return {
      currentPage: 1,
      rows: 0,
      each: 10,
      stateInput: null,
      uqidInput: '',
      ordererInput: '',
      receiverInput: '',
      items: [],
      isBusy: false,
      selectedArray: [],
      selectedDate: null
    }
  },
  computed: {
    stateOptions () {
      return [
        { text: '全部訂單', value: null },
        { text: '待付款', value: 'outstanding' },
        { text: '待出貨', value: 'credited' },
        { text: '待取貨', value: 'ready' },
        { text: '已取貨', value: 'complete' },
        { text: '已棄取', value: 'revoked' }
      ]
    },
    fields () {
      return [
        { key: 'checkbox', label: '選取', tdClass: 'text-center' },
        { key: 'uqid', label: '訂單編號', tdClass: 'text-center' },
        { key: 'time', label: '下單時間', tdClass: 'text-center' },
        { key: 'orderer', label: '購買人姓名', tdClass: 'text-center' },
        { key: 'receiver', label: '取貨人姓名', tdClass: 'text-center' },
        { key: 'total', label: '訂單金額', tdClass: 'text-center' },
        { key: 'pay', label: '支付方式', tdClass: 'text-center' },
        { key: 'state', label: '訂單狀態', tdClass: 'text-center' },
        { key: 'ops', label: '操作', tdClass: 'text-center' }
      ]
    },
    query () {
      const obj = {
        page: this.currentPage,
        each: this.each
      }
      if (this.uqidInput) {
        obj.uqid = this.uqidInput
      }
      if (this.ordererInput) {
        obj.buyer = this.ordererInput
      }
      if (this.receiverInput) {
        obj.receiver = this.receiverInput
      }
      if (this.stateInput) {
        obj.state = this.stateInput
      }
      const str = QueryString.stringify(obj)
      return `?${str}`
    },
    isParticalSelected () {
      return this.selectedArray.length !== 0 && this.items.length !== 0 && this.selectedArray.length !== this.items.length
    }
  },
  methods: {
    start () {
      if (this.isBusy) {
        clearTimeout(this.isBusy)
      }
      this.isBusy = setTimeout(async () => {
        try {
          const { data, headers } = await this.$api.getDel(this.query)
          this.items = data.map(item => {
            const payment = Payments.find(item => item.value === item.pay_type)
            return {
              id: item.id,
              uqid: item.uqid,
              time: moment(item.time).format('YYYY/MM/DD HH:mm:ss'),
              orderer: item.orderer,
              receiver: item.receiver,
              total: item.total,
              pay: payment ? payment.name : '無',
              state: DeliverStates[item.state] || '異常'
            }
          })
          this.rows = headers['shop-option-total'] || 0
        } catch (err) {
          console.log(err)
        } finally {
          this.isBusy = false
        }
      }, 1000)
    },
    async onClickDelete () {
      if (this.isBusy) return
      this.isBusy = true
      const wait = this.selectedArray.map(id => this.$api.delDel(id))
      try {
        await Promise.all(wait)
        this.$bvToast.toast('資料已被刪除。', {
          variant: 'success',
          title: '操作成功'
        })
        this.isBusy = false
        await this.start()
        this.selectedArray = []
      } catch (err) {
        this.$bvToast.toast('連線失敗，資料刪除未成功。', {
          variant: 'danger',
          title: '發生錯誤'
        })
      }
    },
    onClickSelectAll (val) {
      let array = []
      if (val) {
        array = this.items.map(item => item.id)
      }
      this.selectedArray = array
    },
    deliverDownloadLink (format) {
      const date = moment(this.selectedDate).format('YYYYMMDD')
      const obj = { format, date }
      const query = `?${QueryString.stringify(obj)}`
      return this.$api.urlDeliverOutput(query)
    }
  },
  mounted () {
    this.start()
  },
  watch: {
    query () {
      this.start()
    }
  }
}
</script>
